import './B2BUsers.css';

import React, { createContext, useContext, useState } from 'react';
import { Routes } from 'react-router-dom';
import { LoginContext } from '../../App';

import { GitInfoPage, OrganizationsListPage, NewOrganizationPage, UsersListPage, UserNewPage } from './pages/pages';
import ProductsListPage from './pages/ProductsListPage';
import Layout from '../layout/Layout';

import { useB2BRoute } from '../b2b-common/hoc/B2BRoute';
import CompanyProfilePage from './pages/CompanyProfilePage';
import UserProfilePage from './pages/UserProfilePage';
import OrganizationUsers from './pages/OrganizationUsers';

const UsersContext = createContext();

const userRoutes = [
    { path: 'git-info', element: <GitInfoPage />, visibility: 'private' },
    { path: 'organizations', element: <OrganizationsListPage />, visibility: 'private' },
    { path: 'newOrganization', element: <NewOrganizationPage />, visibility: 'private' },
    { path: 'users', element: <UsersListPage />, visibility: 'private' },
    { path: 'newUser', element: <UserNewPage />, visibility: 'private' },
    { path: 'products', element: <ProductsListPage />, visibility: 'private' },

    { path: 'organization-users', element: <OrganizationUsers />, visibility: 'private' },
    { path: 'company-profile', element: <CompanyProfilePage />, visibility: 'private' },
    { path: 'user-profile', element: <UserProfilePage />, visibility: 'private' },
    { path: '*', element: <h1>Not Found</h1> }
];


const B2BUsers = () => {

    const { sidebarOpen, selectedItem } = useContext(LoginContext);
    const [productsData, setProductsData] = useState(null);

    return (
        <UsersContext.Provider value={{ productsData, setProductsData }}>
            <Layout sidebarOpen={sidebarOpen} selectedItem={selectedItem}>
                <Routes>
                    {useB2BRoute(userRoutes)}
                </Routes>
            </Layout>
        </UsersContext.Provider>
    );
};

export default B2BUsers;
export { UsersContext };